import React from 'react';
import PropTypes from 'prop-types';
import {Text} from './Text';
import {formatDuration} from '../utils/moment';

const makeDurationCell = propName => {
  const component = ({row}) => {
    const duration = row[propName];
    return (
      <div style={{display: 'flex', flexDirection: 'row'}}>
        <Text style={{marginRight: '16px', color: 'black'}}>{formatDuration(duration)}</Text>
      </div>
    );
  };

  component.propTypes = {
    row: PropTypes.shape({
      [propName]: PropTypes.string,
    }),
  };

  return component;
};

export default makeDurationCell;
